export const translations = {
  pt: {
    // Step1
    step1Title: "Informe seus dados",
    step1Subtitle:
      "Complete suas informações para prosseguir para o pagamento.",
    fullName: "Nome Completo",
    email: "E-mail",
    phone: "Celular",
    continue: "Continuar",
    back: "Voltar",
    consentText:
      "Ao informar seus dados e seguir para a próxima etapa, você automaticamente concorda com nossa",
    privacyPolicy: "Política de Privacidade",

    // Step2
    step2Title: "Selecione suas opções",
    step2Subtitle: "Escolha o campus e o horário das aulas.",
    campusOption: "Campus Option",
    classes: "Classes",

    // Step3
    step3Title: "Revisão",
    step3Subtitle: "Revise suas informações antes de finalizar.",
    name: "Nome",
    reviewName: "Nome:",
    reviewEmail: "E-mail:",
    reviewPhone: "Celular:",
    reviewCampus: "Campus:",
    reviewClasses: "Classes:",
    price: "Preço:",
    priceInstallment: "4 pagamentos de",
    priceInstallmentWithDiscount: "3 pagamentos de",
    zeroDown: "Entrada zero +",
    discount: "Desconto:",
    finalPrice: "Preço Final:",
    submit: "Enviar",
    termsText: "Confirmo que sou maior de 18 anos e aceito as",
    termsLink: "políticas de uso",
    contactFinanceDepartment:
      "Entre em contato com o Departamento Financeiro para pagamentos",

    // Payment Modal
    payment: "Pagamento",
    cardName: "Nome",
    cardNamePlaceholder: "Nome no cartão",
    cardNumber: "Número do Cartão",
    cardNumberPlaceholder: "0000 0000 0000 0000",
    expiry: "Validade",
    expiryPlaceholder: "MM/AA",
    cvc: "CVC",
    cvcPlaceholder: "000",
    postalCode: "Zipcode",
    postalCodePlaceholder: "00000",
    close: "Fechar",
    pay: "Pagar",
    processing: "Processando...",
    payAmount: "Pagar U$",
    saveCard: "Salvar cartão",
    saveCardConsentLabel:
      "Concordo que este cartão seja salvo para cobranças futuras.",
    saveCardConsentRequired:
      "Para salvar o cartão, marque a opção de consentimento.",
    invalidPaymentForm:
      "Por favor, preencha corretamente os dados do cartão (incluindo zipcode).",
    cardSavedSuccess: "Cartão salvo com sucesso.",

    // Alerts and Messages
    thankYouMessage: "Obrigado por enviar sua inscrição.",
    internalServerError: "Ocorreu um erro interno do servidor.",
    serverConnectionError:
      "Ocorreu um erro de conexão com o servidor em sua inscrição. Mensagem de erro:",
    fileSizeError: "Erro de tamanho de arquivo",
    fileSizeExceeds:
      "o tamanho do arquivo excede o limite máximo. O tamanho máximo permitido é 20 MB.",

    // Campus options
    online: "Online",
    oremInPerson: "Orem (In Person)",
    saltLakeCityInPerson: "Salt Lake City (In Person)",
    seattleInPerson: "Seattle (In Person)",

    // Class options
    tuesdayThursdayEvening:
      "Terça e Quinta | Noite | 6:30 PM a 8:00 PM (Mountain Time)",
    saturdayMorning: "Sábado | Manhã | 9 AM a 12 PM (Mountain Time)",
  },

  en: {
    // Step1
    step1Title: "Enter your information",
    step1Subtitle: "Complete your information to proceed to payment.",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone",
    continue: "Continue",
    back: "Back",
    consentText:
      "By providing your information and proceeding to the next step, you automatically agree to our",
    privacyPolicy: "Privacy Policy",

    // Step2
    step2Title: "Select your options",
    step2Subtitle: "Choose the campus and class schedule.",
    campusOption: "Campus Option",
    classes: "Classes",

    // Step3
    step3Title: "Review",
    step3Subtitle: "Review your information before finalizing.",
    name: "Name",
    reviewName: "Name:",
    reviewEmail: "Email:",
    reviewPhone: "Phone:",
    reviewCampus: "Campus:",
    reviewClasses: "Classes:",
    price: "Price:",
    priceInstallment: "4 payments of",
    priceInstallmentWithDiscount: "3 payments of",
    zeroDown: "Zero down +",
    discount: "Discount:",
    finalPrice: "Final Price:",
    submit: "Submit",
    termsText: "I confirm that I am over 18 years old and accept the",
    termsLink: "terms of use",
    contactFinanceDepartment: "Contact the Finance Dept. for payments",

    // Payment Modal
    payment: "Payment",
    cardName: "Name",
    cardNamePlaceholder: "Name on card",
    cardNumber: "Card Number",
    cardNumberPlaceholder: "0000 0000 0000 0000",
    expiry: "Expiry",
    expiryPlaceholder: "MM/YY",
    cvc: "CVC",
    cvcPlaceholder: "000",
    postalCode: "Zipcode",
    postalCodePlaceholder: "00000",
    close: "Close",
    pay: "Pay",
    processing: "Processing...",
    payAmount: "Pay $",
    saveCard: "Save card",
    saveCardConsentLabel: "I agree to save this card for future payments.",
    saveCardConsentRequired: "To save the card, please check the consent box.",
    invalidPaymentForm:
      "Please fill in the card details correctly (including zipcode).",
    cardSavedSuccess: "Card saved successfully.",

    // Alerts and Messages
    thankYouMessage: "Thank you for submitting your application.",
    internalServerError: "An internal server error has occurred.",
    serverConnectionError:
      "A server connection error occurred in your application. Error message:",
    fileSizeError: "File size error",
    fileSizeExceeds:
      "file size exceeds maximum limit. Maximum allowed file size is 20 MB.",

    // Campus options
    online: "Online",
    oremInPerson: "Orem (In Person)",
    saltLakeCityInPerson: "Salt Lake City (In Person)",
    seattleInPerson: "Seattle (In Person)",

    // Class options
    tuesdayThursdayEvening:
      "Tuesday and Thursday | Evening | 6:30 PM to 8:00 PM (Mountain Time)",
    saturdayMorning: "Saturday | Morning | 9 AM to 12 PM (Mountain Time)",
  },

  es: {
    // Step1
    step1Title: "Ingrese su información",
    step1Subtitle: "Complete su información para proceder al pago.",
    fullName: "Nombre Completo",
    email: "Correo Electrónico",
    phone: "Teléfono",
    continue: "Continuar",
    back: "Volver",
    consentText:
      "Al proporcionar su información y proceder al siguiente paso, usted acepta automáticamente nuestra",
    privacyPolicy: "Política de Privacidad",

    // Step2
    step2Title: "Seleccione sus opciones",
    step2Subtitle: "Elija el campus y el horario de las clases.",
    campusOption: "Opción de Campus",
    classes: "Clases",

    // Step3
    step3Title: "Revisión",
    step3Subtitle: "Revise su información antes de finalizar.",
    name: "Nombre",
    reviewName: "Nombre:",
    reviewEmail: "Correo Electrónico:",
    reviewPhone: "Teléfono:",
    reviewCampus: "Campus:",
    reviewClasses: "Clases:",
    price: "Precio:",
    priceInstallment: "4 pagos de",
    priceInstallmentWithDiscount: "3 pagos de",
    zeroDown: "Entrada cero +",
    discount: "Descuento:",
    finalPrice: "Precio Final:",
    submit: "Enviar",
    termsText: "Confirmo que soy mayor de 18 años y acepto las",
    termsLink: "políticas de uso",
    contactFinanceDepartment: "Contacte al Departamento de Finanzas para pagos",

    // Payment Modal
    payment: "Pago",
    cardName: "Nombre",
    cardNamePlaceholder: "Nombre en la tarjeta",
    cardNumber: "Número de Tarjeta",
    cardNumberPlaceholder: "0000 0000 0000 0000",
    expiry: "Vencimiento",
    expiryPlaceholder: "MM/AA",
    cvc: "CVC",
    cvcPlaceholder: "000",
    postalCode: "Código Postal",
    postalCodePlaceholder: "00000",
    close: "Cerrar",
    pay: "Pagar",
    processing: "Procesando...",
    payAmount: "Pagar $",
    saveCard: "Guardar tarjeta",
    saveCardConsentLabel:
      "Acepto que esta tarjeta se guarde para futuros cobros.",
    saveCardConsentRequired:
      "Para guardar la tarjeta, marque la opción de consentimiento.",
    invalidPaymentForm:
      "Por favor, complete correctamente los datos de la tarjeta (incluido el código postal).",
    cardSavedSuccess: "Tarjeta guardada con éxito.",

    // Alerts and Messages
    thankYouMessage: "Gracias por enviar su solicitud.",
    internalServerError: "Ha ocurrido un error interno del servidor.",
    serverConnectionError:
      "Ocurrió un error de conexión con el servidor en su solicitud. Mensaje de error:",
    fileSizeError: "Error de tamaño de archivo",
    fileSizeExceeds:
      "el tamaño del archivo excede el límite máximo. El tamaño máximo permitido es 20 MB.",

    // Campus options
    online: "En Línea",
    oremInPerson: "Orem (En Persona)",
    saltLakeCityInPerson: "Salt Lake City (En Persona)",
    seattleInPerson: "Seattle (En Persona)",

    // Class options
    tuesdayThursdayEvening:
      "Martes y Jueves | Noche | 6:30 PM a 8:00 PM (Mountain Time)",
    saturdayMorning: "Sábado | Mañana | 9 AM a 12 PM (Mountain Time)",
  },
};

// Hook será criado em um arquivo separado para evitar dependência circular
